// engine
import { ArController } from '@aceroll/core';

export class RoundFail extends ArController {
    async onStart() {
        const { slotMachine } = this.context.currentLayout;
        await slotMachine.forceStop();

        this.stop();
    }
}